import _ from 'lodash';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import * as storeGetters from '~/store/getters';
import Debug from '~/utils/debug';
import Markdown from '~/components/markdown/Markdown.vue';
import createPreviewTemplate from './previewtemplate.pug';

const previewTemplate = createPreviewTemplate();

const debug = Debug('FileUpload');

export default {
  props: {
    files: {
      type: Array,
      default: () => ([]),
    },
    single: {
      type: Boolean,
      default: () => false,
    },
    acceptedFiles: {
      type: String,
      default: () => '.pdf,.jpeg,.jpg,.png,.gif,.mp4,.mov,.qt,.avi,.csv,.txt,.xls,.xlsx,.doc,.docx',
    },
    rules: {
      type: String,
      default: () => '',
    },
    uploadButtonText: {
      type: String,
      default: () => 'campaign_field.placeholder.images',
    },
  },
  components: {
    Markdown,
    'vue-dropzone': vue2Dropzone,
  },
  computed: {
    dropzoneOptions() {
      return {
        url: `${storeGetters.apiUrl()}v1/upload`,
        headers: {
          Authorization: `Bearer ${storeGetters.apiKey()}`,
        },
        thumbnailWidth: 133,
        thumbnailHeight: 133,
        timeout: 0,
        maxFiles: this.single ? 1 : 50,
        maxFilesize: 200, // megabytes
        acceptedFiles: this.acceptedFiles,
        addRemoveLinks: true,
        dictDefaultMessage: this.$t(this.uploadButtonText),
        dictRemoveFile: this.$t('terms.misc.remove'),
        dictCancelUpload: this.$t('terms.misc.cancel'),
        dictCancelUploadConfirmation: this.$t('terms.misc.confirm'),
        previewTemplate,
      };
    },
  },
  methods: {
    success(file, response) {
      file.id = response.result.id;
      file.path = response.result.path;
      file.thumbnail = response.result.thumbnail;

      this.files.push(response.result);
      this.$emit('update:files', this.files);
    },
    onComplete(file) {
      if (file.thumbnail && this.$refs.fileUpload !== 'undefined') {
        const mockFile = {
          name: file.name,
          size: file.size,
          accepted: true,
          kind: 'image',
          upload: {
            filename: file.name,
          },
          dataURL: `${file.thumbnail}?bypass-s3-header-bug`,
        };
        const dropzone = this.$refs.fileUpload.dropzone;
        dropzone.createThumbnailFromUrl(
          mockFile,
          this.dropzoneOptions.thumbnailWidth,
          this.dropzoneOptions.thumbnailHeight,
          'crop',
          false,
          (thumbnail) => {
            dropzone.emit('thumbnail', file, thumbnail);
          },
          true,
        );
      }
    },
    removedFile(file) {
      const index = _.findIndex(this.files, { id: file.id });
      if (index >= 0) {
        this.files.splice(index, 1);
        this.$emit('update:files', this.files);
      }

      // Basically vue-dropzone increases maxFiles, but only after this event is completed.
      // "Hackfix" - we manually increase maxFiles and later decrease, just to use accept()
      const fix = this.dropzoneOptions.maxFiles > this.$refs.fileUpload.dropzone.options.maxFiles;
      if (fix) {
        this.$refs.fileUpload.dropzone.options.maxFiles += 1;
      }
      const rejectedFiles = this.$refs.fileUpload.getRejectedFiles().filter(f => !f.manuallyAdded);
      if (rejectedFiles) {
        rejectedFiles.forEach(rejected => {
          this.$refs.fileUpload.accept(rejected, error => {
            if (!error || error === ' ') {
              rejected.accepted = true;
              rejected.status = 'added';

              this.$refs.fileUpload.dropzone.enqueueFile(rejected);
              rejected.previewElement.classList.remove('dz-error');
            }
          });
        });

        if (!this.$refs.fileUpload.getRejectedFiles().length) {
          this.setError(null);
        }
      }
      if (fix) {
        this.$refs.fileUpload.dropzone.options.maxFiles -= 1;
      }
    },
    setError(msg) {
      this.$emit('update:files-error', msg);
    },
  },
  mounted() {
    debug.info('mounted');
    this.files.forEach(f => {
      if (f.content_type && !f.type) {
        f.type = f.content_type;
      }
      this.$refs.fileUpload.manuallyAddFile(f, f.thumbnail);
    });
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/file-upload/FileUpload.js